import { render, staticRenderFns } from "./RelatorioFrota.vue?vue&type=template&id=5e14f4c3&"
import script from "./RelatorioFrota.vue?vue&type=script&lang=js&"
export * from "./RelatorioFrota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports